package com.essntl.features.address.data.repository

import com.essntl.core.supabase.getById
import com.essntl.core.supabase.insert
import com.essntl.core.supabase.update
import com.essntl.core.utils.repository.Repository
import com.essntl.features.address.data.supabase.AddressSupabaseDataSource
import com.essntl.features.address.data.supabase.GooglePlaceDto
import com.essntl.features.address.data.supabase.SetPlaceDto
import com.essntl.features.address.data.supabase.toRequestMap
import com.essntl.features.address.domain.model.AddressModel
import com.essntl.features.address.domain.model.GooglePlaceModel
import com.essntl.features.address.domain.repository.AddressRepository
import io.github.jan.supabase.SupabaseClient
import io.github.jan.supabase.functions.functions
import io.ktor.client.call.body
import org.koin.core.annotation.Single

@Single(binds = [AddressRepository::class])
internal class AddressRepositoryImpl(
    private val supabase: SupabaseClient,
    private val addressDataSource: AddressSupabaseDataSource,
) : Repository(), AddressRepository {

    override suspend fun getPlaces(searchText: String): Result<List<GooglePlaceModel>> =
        runCatching {
            supabase.functions.invoke(
                function = "google-places-autocomplete?searchTerm=$searchText&short=true",
            ).body<List<GooglePlaceDto>>()
                .map { dto -> dto.toModel() }
        }

    override suspend fun setPlace(placeId: String): Result<String> =
        runCatching {
            supabase.functions.invoke(
                function = "google-places-autocomplete/details?placeId=$placeId",
            ).body<SetPlaceDto>()
                .addressId
        }

    override suspend fun getAddress(id: String): Result<AddressModel> =
        runCatching {
            addressDataSource
                .getById(id = id)
                .toModel()
        }

    override suspend fun insert(address: AddressModel): Result<AddressModel> =
        runCatching {
            addressDataSource.insert(
                requestMap = address.toRequestMap(),
            ).toModel()
        }

    override suspend fun update(address: AddressModel): Result<AddressModel> =
        runCatching {
            addressDataSource
                .update(
                    id = address.id,
                    requestMap = address.toRequestMap(),
                ).toModel()
        }
}
